import { UPLOAD_WEIGHT_DISPUTE_REQUEST, UPLOAD_WEIGHT_DISPUTE_SUCCESS, UPLOAD_WEIGHT_DISPUTE_FAILURE, } from "../../actions";
const initialState = {
    uploading: false,
    success: false,
    error: null,
    data: null,
};
const weightDisputeFileUploadReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_WEIGHT_DISPUTE_REQUEST:
            return Object.assign(Object.assign({}, state), { uploading: true, success: false, error: null });
        case UPLOAD_WEIGHT_DISPUTE_SUCCESS:
            return Object.assign(Object.assign({}, state), { uploading: false, success: true, error: null, data: action.payload });
        case UPLOAD_WEIGHT_DISPUTE_FAILURE:
            return Object.assign(Object.assign({}, state), { uploading: false, success: false, error: action.payload });
        default:
            return state;
    }
};
export default weightDisputeFileUploadReducer;
